import Vue from 'vue';
import VueRouter from 'vue-router';
import HomeView from '@/views/HomeView.vue';
// import ThreeView from '../views/pages/ThreeView.vue'
import LoginView from "@/views/pages/LoginView.vue";
import WebView from "@/views/pages/WebView.vue";
import MobView from "@/views/pages/MobView.vue";
import CateView from "@/views/pages/CateView.vue";
import ContentView from "@/views/pages/ContentView.vue";
import getContentView from "@/views/pages/getContentView.vue";
import ProductView from "@/views/pages/ProductView.vue";
import getProductView from "@/views/pages/getProductView.vue";
import BannerView from "@/views/pages/BannerView.vue";
import getBannerView from "@/views/pages/getBannerView.vue";
import getLinkView from "@/views/pages/getLinkView.vue";
import LinkView from "@/views/pages/LinkView.vue";
import WaterView from "@/views/pages/WaterView.vue";
import LabelView from "@/views/pages/LabelView.vue";
import getLabelView from "@/views/pages/getLabelView.vue";
import MessageView from "@/views/pages/MessageView.vue";
import UserView from "@/views/pages/UserView.vue";
import AccessView from "@/views/pages/AccessView.vue";
import LangView from "@/views/pages/LangView.vue";
import HistoryView from "@/views/pages/HistoryView.vue";
import getHistoryView from "@/views/pages/getHistoryView.vue";
import DownloadView from "@/views/pages/DownloadView.vue";
import getDownloadView from "@/views/pages/getDownloadView.vue";
import getTypeView from "@/views/pages/getTypeView.vue";
import LeaderView from "@/views/pages/LeaderView.vue";
import TypeView from "@/views/pages/TypeView.vue";
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta:{
      requireLogin:true,
      title:'首页'
    },
    children: [
      {
        path: '/leader',
        name: 'LeaderView',
        component: LeaderView,
        meta:{
          requireLogin:true,
          title:'数据导入',
        }
      },
      {
        path: '/history',
        name: 'HistoryView',
        component: HistoryView,
        meta:{
          requireLogin:true,
          title:'历程管理',
        }
      },
      {
        path: '/type',
        name: 'TypeView',
        component: TypeView,
        meta:{
          requireLogin:true,
          title:'类型管理',
        }
      },
      {
        path: '/gettype/:id',
        name: 'getTypeView',
        component: getTypeView,
        meta:{
          requireLogin:true,
          title:(route) => `类型详情 - ${route.params.id}`,
          title2:`类型详情-新`
        }
      },
      {
        path: '/gethistory',
        name: 'getHistoryView',
        component: getHistoryView,
        meta:{
          requireLogin:true,
          title:'历程详情',
        }
      },
      {
        path: '/webbase',
        name: 'WebView',
        component: WebView,
        meta:{
          requireLogin:true,
          title:'web端设置'
        }
      },
      {
        path: '/mobbase',
        name: 'MobView',
        component: MobView,
        meta:{
          requireLogin:true,
          title:'手机端',
        }
      },
      {
        path: '/category',
        name: 'CateView',
        component: CateView,
        meta:{
          requireLogin:true,
          title:'栏目管理',
        }
      },
      {
        path: '/content',
        name: 'ContentView',
        component: ContentView,
        meta:{
          requireLogin:true,
          title:'资讯管理',
        }
      },
      {
        path: '/getContent/:id',
        name: 'getContentView',
        component: getContentView,
        meta:{
          requireLogin:true,
          title:(route) => `资讯详情 - ${route.params.id}`,
          title2:`资讯详情-新`
        }
      },
      {
        path: '/product',
        name: 'ProductView',
        component: ProductView,
        meta:{
          requireLogin:true,
          title:'产品管理'
        }
      },
      {
        path: '/getproduct/:id',
        name: 'getProductView',
        component: getProductView,
        meta: {
          requireLogin: true,
          title:(route) => `产品详情 - ${route.params.id}`,
          title2:`产品详情-新`
        }
      },
      {
        path: '/banner',
        name: 'BannerView',
        component: BannerView,
        meta:{
          requireLogin:true,
          title:'banner管理',
        }
      },
      {
        path: '/getbanner/:id',
        name: 'getBannerView',
        component: getBannerView,
        meta:{
          requireLogin:true,
          title:(route) => `banner详情 - ${route.params.id}`,
          title2:`banner详情-新`
        }
      },
      {
        path: '/link',
        name: 'LinkView',
        component: LinkView,
        meta:{
          requireLogin:true,
          title:'友链管理',
        }
      },{
        path: '/lang',
        name: 'LangView',
        component: LangView,
        meta:{
          requireLogin:true,
          title:'基础语言',
        }
      },
      {
        path: '/getlink/:id',
        name: 'getLinkView',
        component: getLinkView,
        meta:{
          requireLogin:true,
          title:(route) => `友链详情 - ${route.params.id}`,
          title2:`友链详情-新`
        }
      },
      {
        path: '/water',
        name: 'WaterView',
        component: WaterView,
        meta:{
          requireLogin:true,
          title:'水印设置'
        }
      },{
        path: '/label',
        name: 'LabelView',
        component: LabelView,
        meta:{
          requireLogin:true,
          title:'分类管理',
        }
      },{
        path: '/getlabel/:id',
        name: 'getLabelView',
        component: getLabelView,
        meta:{
          requireLogin:true,
          title:(route) => `分类详情 - ${route.params.id}`,
          title2:`分类详情-新`
        }
      },{
        path: '/message',
        name: 'MessageView',
        component: MessageView,
        meta:{
          requireLogin:true,
          title:'留言管理',
        }
      },{
        path: '/user',
        name: 'UserView',
        component: UserView,
        meta:{
          requireLogin:true,
          title:'账号管理',
        }
      },{
        path: '/access',
        name: 'AccessView',
        component: AccessView,
        meta:{
          requireLogin:true,
          title:'访问记录',
        }
      },{
        path: '/download',
        name: 'DownloadView',
        component: DownloadView,
        meta:{
          requireLogin:true,
          title:'下载管理',
        }
      },{
        path: '/getdownload/:id',
        name: 'getDownloadView',
        component: getDownloadView,
        meta:{
          requireLogin:true,
          title:(route) => `下载详情 - ${route.params.id}`,
          title2:`下载详情-新`
        }
      }
    ]
  },
  {
    path: '/login',
    name:'login',
    component: LoginView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
